import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import cn from 'classnames';
import _ from 'lodash';
import './ShopAddPostSelectType.scss';

import { openConnectInstagramModal } from '../../../Actions/UIActions';
import { connectInstagram } from '../../../Actions/UserActions';
import { getSocialAccount } from '../../../Helpers/user_helpers';
import { openInstagramAuthModal, openYoutubeAuthModal, openTikTokAuthModal, getSocialIconForType } from '../../../Helpers/social_helpers';

import Modal from '../../General/Modal';

const ShopAddPostSelectType = props => {
  const { user } = props;

  const instaAccount = getSocialAccount(user, 'instagram');
  const youtubeAccount = getSocialAccount(user, 'youtube');
  const tiktokAccount = getSocialAccount(user, 'tiktok');

  const attemptConnectingType = type => {
    switch (type) {
      case 'instagram':
        return;
      case 'youtube':
        return openYoutubeAuthModal({ useFullUrl: true });
      case 'tiktok':
        return openTikTokAuthModal({ useFullUrl: true });
      default:
        return null;
    }
  };

  let options = [
    {
      type: 'instagram',
      label: 'Instagram',
      needsConnection: !instaAccount,
      connect: () => {
        openInstagramAuthModal(
          async authResponse => {
            props
              .connectInstagram(authResponse)
              .then(resp => props.selectMediaType('instagram'))
              .catch(errorMessage => window.ALERT.error(errorMessage));
          },
          () => this.props.openConnectInstagramModal()
        );
      },
      addMedia: () => props.selectMediaType('instagram')
    },
    {
      type: 'youtube',
      label: 'Youtube',
      needsConnection: !youtubeAccount,
      connect: () => attemptConnectingType('youtube'),
      addMedia: () => props.selectMediaType('youtube')
    },
    {
      type: 'tiktok',
      label: 'Tiktok',
      needsConnection: !tiktokAccount,
      connect: () => attemptConnectingType('tiktok'),
      addMedia: () => props.selectMediaType('tiktok')
    }
  ].map(option => ({
    ...option,
    addMedia: () => props.selectMediaType(option.type)
  }));

  options = _.orderBy(options, ['needsConnection'], ['asc']);

  return (
    <Modal
      visible
      close={props.closeModal}
      className='shop-add-post-select-type-outer-container'
      innerClassName='shop-add-post-select-type-inner-container'
      contentClassName='shop-add-post-select-type-content-container'
      showClose
      isNestedModal
      smallForm
    >
      <div className='header-container'>
        <div className='header'>Select Type</div>
        <div className='subheader'>Which platform do you want to add a collection for?</div>
      </div>
      <div className='options-container'>
        {options.map((option, idx) => {
          const { type, label, needsConnection, connect, addMedia } = option;
          const select = () => (needsConnection ? connect() : addMedia());
          return (
            <div onClick={select} key={type} className={cn('option', { 'needs-connection': needsConnection })}>
              <div className='logo'>
                <img src={getSocialIconForType(type)} alt={label} />
              </div>
              <div className='label'>{needsConnection ? `Connect ${label}` : label}</div>
            </div>
          );
        })}
        <div onClick={props.addManualCollection} className='option manual'>
          <div className='logo'>
            <FontAwesomeIcon icon={faPlus} />
          </div>
          <div className='label'>{props.isAddingManualCollection ? 'Adding...' : 'Manual Post'}</div>
        </div>
      </div>
    </Modal>
  );
};

ShopAddPostSelectType.propTypes = {
  // From Inside
  user: PropTypes.object.isRequired,
  openConnectInstagramModal: PropTypes.func.isRequired,
  connectInstagram: PropTypes.func.isRequired,

  // From Outside
  closeModal: PropTypes.func.isRequired,
  selectMediaType: PropTypes.func.isRequired,
  addManualCollection: PropTypes.func.isRequired,
  isAddingManualCollection: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  openConnectInstagramModal,
  connectInstagram
})(ShopAddPostSelectType);
